import { IntlShape } from 'react-intl/lib';

import { EnumCardItemStatus, ICardItem } from '../types';

const assignTipText =
  (intl: IntlShape) =>
  (item: ICardItem): ICardItem => ({
    ...item,
    tipText: (() => {
      switch (item.status) {
        case EnumCardItemStatus.addDocument:
          return intl.formatMessage({
            defaultMessage: 'Add documents',
            id: 'uolx/v',
            description: 'todo card car/driver status',
          });
        case EnumCardItemStatus.documentsError:
          return intl.formatMessage({
            defaultMessage: 'Documents error',
            id: 'QW4nux',
            description: 'todo card car/driver status',
          });
        case EnumCardItemStatus.documentsExpired:
          return intl.formatMessage({
            defaultMessage: 'Expired documents',
            id: 'WLZt0z',
            description: 'todo card car/driver status',
          });
        case EnumCardItemStatus.inReview:
          return intl.formatMessage({
            defaultMessage: 'In review',
            id: '+I3iZ6',
            description: 'todo card car/driver status',
          });
        case EnumCardItemStatus.approved:
          return intl.formatMessage({
            defaultMessage: 'Approved',
            id: 'ngu9gy',
            description: 'todo card car/driver status',
          });
        case EnumCardItemStatus.waitingForApproval:
          return intl.formatMessage({
            defaultMessage: 'Pending approval',
            id: 'P3eKlW',
            description: 'todo card car/driver status',
          });
        default:
          return '';
      }
    })(),
  });

const assignTipTextForCardItems = (intl: IntlShape, items: ICardItem[]): ICardItem[] =>
  items.map(assignTipText(intl));

export { assignTipTextForCardItems };
